import React, { Component } from "react";
import { Form, FormGroup, ControlLabel, Radio } from "react-bootstrap";
import SignatureForm from "../SignatureForm/SignatureForm";
import "./EmployeeInformation.css";
import { onSignatureTypeSelect } from "../../actions/SignatureTypeAction";
import { connect } from "react-redux";

class EmployeeInformation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      clientFacing: "yes"
    };

    this.positionChoice = this.positionChoice.bind(this);
  }

  positionChoice(e) {
    this.setState({
      clientFacing: e.target.value
    });
    this.props.onSignatureTypeSelect(e.target.value);
  }

  render() {
    let formType = null;
    if (this.state.clientFacing !== null) {
      formType = <SignatureForm clientFacing={this.state.clientFacing} />;
    } else {
      formType = null;
    }
    return (
      <Form>
        <FormGroup controlId={`1`} onChange={this.positionChoice}>
          <ControlLabel className="client-facing-question">
            Are you in Sales, Fulfillment, or Support?
          </ControlLabel>
          <Radio name="radioGroup" inline value="yes" defaultChecked={this.state.clientFacing}>
            Yes
          </Radio>
          <Radio name="radioGroup" inline value="no">
            No
          </Radio>
        </FormGroup>
        {formType}
      </Form>
    );
  }
}

const mapStateToProps = state => {
  return {
    clientFacing: state.form.clientFacing
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSignatureTypeSelect: value => dispatch(onSignatureTypeSelect(value))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(
  EmployeeInformation
);



// WEBPACK FOOTER //
// ./src/components/EmployeeInformation/EmployeeInformation.js